module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAAAXNSR0IArs4c6QAAAP1JREFUOBGtkzEKwkAURKMkjaWCjWeIHiCVEBByB8HbWHmAWOlZrGwEBa0srAUbUbGROE8SiGFdYsiHx+7+PzPZEOI4aSVJ0hYzsRZXsRHjbM6qc4NeOkODFk87r0MYirMw1VxNgoC9qfCGhCLqad2KDo0ftUj7kx9z2hfR53ax6ZEVe3FTqQHxNVXAK98V1qop8MENjzWFEXMkcFlj4JKP4oldxY+Qt5HhfS6nzUDc8tM/93gHX2+qRiSefwYhxxN9hWUHDUaCX6psoR1lfuMqgS9OJRLR+MaQYlPCrlhZQpl1iz7rWQZXTMVLZMWenms124YyD8VB7NnbtMzex79VNxUXOOsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/like.png
// module id = 2250
// module chunks = 2